<template>
<div class="my-auto w-100 main-area" v-if="allEvents.length > 0">
  <div class="profile-detail">
      <TitleContainer :title="'受付中：キャリア採用オンラインイベント'" />
      <EventCard
        v-for="event in allEvents"
        :key="event._id"
        :event="event"
        :use-memoize="true"
        :show-mobile-layout="true"
        @click="navigateToEventDetail"
      />

    </div>
  <!-- ends profile-detail -->
</div>
</template>
<script>
import { mapActions, mapGetters } from 'vuex';
import TitleContainer from './TitleContainer.vue';
import EventCard from './EventCard.vue';

export default {
  name: 'Event',
  components: {
    TitleContainer,
    EventCard,
  },
  data() {
    return {
      events: [],
    };
  },
  computed: {
    ...mapGetters({
      profile: 'getProfile',
      allEvents: 'getAllEvents',
    }),
    allEventz() {
      return [];
    },
    checkClass() {
      if (this.showSharingConfirm) {
        return 'swal-overlay swal-overlay--show-modal';
      }
      return 'swal-overlay';
    },
  },
  methods: {
    ...mapActions({
      setProfile: 'setProfile',
      setAllEvents: 'setAllEvents',
    }),
    navigateToEventDetail(eventId) {
      this.$router.push({ name: 'EventDetail', params: { id: eventId } });
    },
    openNoteLink() {
      window.open('https://note.blm.co.jp/', '_blank');
    },
    formatEventTime(eventDateFrom) {
      const formattedTime = moment(eventDateFrom)
        .utc()
        .format('HH:mm');
      return formattedTime;
    },
    formatApplicationDeadline(deadlineDate) {
      const formattedDate = moment(deadlineDate)
        .locale('ja-JP')
        .utc()
        .format('M/D(ddd)');
      const formattedTime = moment(deadlineDate)
        .utc()
        .format('HH:mm');
      return `${formattedDate} ${formattedTime} 締切`;
    },
    getApplicationButtonClass(event) {
      if (this.checkApplicationStatus(event)) {
        return 'applied-status';
      } else {
        return 'not-applied-status';
      }
    },
    getApplicationButtonText(event) {
      if (this.checkApplicationStatus(event)) {
        return '申込み済';
      } else {
        return '未申込み';
      }
    },
  },
  async created() {
    await this.setProfile();
    await this.setAllEvents();
  },
};
</script>
<style scoped>
.main-area {
  background-color: #E7F6F6;
}

.event-footer {
  height: 47px;
  background-color: #F9FAFB;
    text-align: center;
  padding: 2px 0px 0px 0px;
  margin-top: 20px;
  font-size: 14px;
  font-weight: bold;
  color: #666666;
}

.footer-link {
  color: #0066cc;
  text-decoration: underline;
    cursor: pointer;
}

@media (max-width: 530px) {
  .main-area {
    box-shadow: none;
  }
}
</style>
